// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dark-theme {
	--bg: #1c1b20;
	--bg-secondary: #2e2d35;
	--bg-column: #36454f;
	--bg-item-selected: #2e2d35;
	--bg-item-active: #46464a;
	--text: #ffffff;
	--body-bg: #1c1b20;
	--sidenav-bg: #2e2d35;
	--table-cell-row-hover: #26252b;
	--form-item-label: rgba(255, 255, 255, 1);
	/* --table-head: #424242; */
	--input-border: none;
	--quick-links-bg: #2e2d35;
	--form-color: #525252;
	--text-color-2: #7858a6;
	--text-color-secondary: #864879;
	--text-color-hr: #864879;
	--shadow-color: #3730a3;
}

.light-theme {
	--bg: #f5f4f4;
	--bg-secondary: #ffffff;
	--bg-column: #f7f7f7;
	--bg-item-selected: #e6f7ff;
	--bg-item-active: #cef0ff;
	--text: #000000;
	--body-bg: #f8f8ff;
	--sidenav-bg: #344d67;
	--table-cell-row-hover: #fafafa;
	--form-item-label: rgba(0, 0, 0, 0.85);
	--table-head: rgb(51, 51, 51);
	--input-border: 1px solid #d9d9d9;
	--quick-links-bg: #f4f4f4;
	--form-color: #e6e6e6;
	--text-color-2: #37306b;
	--text-color-secondary: #146c94;
	--text-color-hr: #e2e2e2;
	--shadow-color: #c7d2fe;
}

body {
	background-color: var(--body-bg) !important;
}

.ant-shadow {
	border-radius: 16px;
	margin-right: 24px;
	box-shadow: 0 1px 15px -1px var(--shadow-color),
		0 1px 6px -4px var(--shadow-color);
}

.date {
	font-family: Nunito, Roboto, sans-serif;
	box-sizing: border-box;
	position: relative;
	margin: 0 auto;
	top: 30px;

	border: 4px double #51b27f;
	border-radius: 3px;
	text-align: center;
}

.date .month {
	letter-spacing: 2px;
	position: absolute;
	left: 0;
	right: 0;
	bottom: -25px;
	text-transform: uppercase;
	text-align: center;
}

.date .day {
	background: var(--bg-secondary) !important;
	display: inline-block;
	font-size: 2em;
	margin: 5px 0 0 -15px;
}

.date sup {
	position: relative;
	bottom: 10px;
}

.ant-card {
	background-color: var(--bg-secondary) !important;
	color: var(--text) !important;
}

.new-card {
	background-color: var(--bg-secondary) !important;
}

.new-column-card {
	background-color: var(--bg-column) !important;
}

.ant-row {
	color: var(--text) !important;
}

.new-hr {
	border-top: 1px solid var(--text-color-hr) !important;
}

.txt-color {
	color: var(--text) !important;
}

.txt-color-2 {
	color: var(--text-color-2) !important;
}

.txt-color-secondary {
	color: var(--text-color-secondary) !important;
}

.form-color {
	color: var(--form-color) !important;
}

.ant-layout {
	background-color: var(--bg) !important;
}

.ant-page-header-heading-title {
	color: var(--text) !important;
}

.ant-page-header-back-button anticon {
	color: var(--text) !important;
}

.ant-layout-sider {
	background: white !important;
	color: black !important;
}

.ant-modal-content,
.ant-modal-header,
.ant-modal-title {
	background-color: var(--bg-secondary) !important;
	color: var(--text) !important;
}

.ant-menu.ant-menu-dark,
.ant-menu-dark .ant-menu-sub,
.ant-menu.ant-menu-dark .ant-menu-sub {
	background: var(--sidenav-bg) !important;
}

.logout-text {
	color: var(--text) !important;
}

.card-body {
	color: var(--text) !important;
}

.ant-typography {
	color: var(--text) !important;
}

.ant-form-item-label > label {
	color: var(--form-item-label) !important;
}

.ant-table {
	color: var(--text) !important;
}

.ant-table-cell-row-hover {
	background-color: var(--table-cell-row-hover) !important;
}

.ant-table-tbody > tr > .ant-table-cell {
	padding-top: 0.5rem !important;
	padding-bottom: 0.5rem !important;
}

.card-header {
	background-color: var(--bg) !important;
}

.card-header > div > h5 {
	color: var(--text) !important;
}

.table-responsive > h5 {
	color: var(--text) !important;
}

.card-custom {
	background-color: var(--bg) !important;
}

.card-custom h5 {
	color: var(--text) !important;
}

.card-custom h4 {
	color: var(--text) !important;
}

.report-section-table,
.detail-account-table {
	color: var(--text) !important;
}

.report-section-table h5,
.detail-account-table h5 {
	color: var(--text) !important;
}

.report-section-table thead,
.detail-account-table thead {
	background-color: var(--table-head) !important;
}

.report-section-table thead th,
.detail-account-table thead th {
	background-color: var(--table-head) !important;
}

.ant-empty-description {
	color: var(--text) !important;
}

.ant-table-placeholder:hover .ant-table-cell {
	background-color: var(--table-cell-row-hover) !important;
}

.loading h5 {
	color: var(--text) !important;
}

.ant-page-header-heading {
	color: var(--text) !important;
}

.ant-page-header-back-button {
	color: var(--text) !important;
}

.range-picker {
	background-color: var(--bg-secondary) !important;
	border: var(--input-border) !important;
}

.ant-picker {
	background-color: var(--bg-secondary) !important;
}

.ant-picker-input > input {
	color: var(--text) !important;
}

.ant-picker-separator,
.ant-picker-suffix,
.ant-picker-clear {
	color: var(--text) !important;
}

.ant-input {
	color: var(--text) !important;
	background-color: var(--bg-secondary) !important;
}

.ant-btn-dashed {
	color: var(--text) !important;
	background-color: var(--bg) !important;
}

.ant-btn-dashed:hover {
	background-color: var(--bg-secondary) !important;
}

.ant-input-number {
	color: var(--text) !important;
	background-color: var(--bg-secondary) !important;
}

.ant-input-number-status-error:not(.ant-input-number-disabled):not(
		.ant-input-number-borderless
	).ant-input-number,
.ant-input-number-status-error:not(.ant-input-number-disabled):not(
		.ant-input-number-borderless
	).ant-input-number:hover {
	background-color: var(--bg-secondary) !important;
}

.ant-input-status-error:not(.ant-input-disabled):not(
		.ant-input-borderless
	).ant-input,
.ant-input-status-error:not(.ant-input-disabled):not(
		.ant-input-borderless
	).ant-input:hover {
	background-color: var(--bg) !important;
}

.ant-input-number-handler-wrap span {
	color: var(--text) !important;
	background-color: var(--bg-secondary) !important;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector {
	color: var(--text) !important;
	background-color: var(--bg-secondary) !important;
}

.ant-select-dropdown {
	color: var(--text) !important;
	background-color: var(--bg) !important;
}

.ant-select-item .ant-select-item-option {
	color: var(--text) !important;
	background-color: var(--bg-secondary) !important;
}

.ant-select-item-option-content {
	color: var(--text) !important;
}

.ant-select-multiple .ant-select-selection-item {
	background-color: transparent !important;
}

.ant-select-item-option-selected {
	background-color: var(--bg-item-selected) !important;
}

.ant-select-item-option-active:not(.ant-select-item-option-disabled) {
	background-color: var(--bg-item-active) !important;
}

.dashboard-card {
	color: white;
	border: none;
	border-radius: 10px;
}

.dashboard-card h3 {
	color: white;
}

.dashboard-card span {
	color: white;
}

.dashboard-card-bg {
	background-color: var(--bg-secondary);
}

.ant-card-head-title {
	color: var(--text) !important;
}

.ant-card-head {
	background-color: var(--bg-secondary) !important;
}

.ant-card-bordered {
	background-color: var(--bg-secondary) !important;
	border: var(--input-border) !important;
}

.ant-page-header {
	background-color: var(--bg-secondary) !important;
	color: var(--text) !important;
	border: var(--input-border) !important;
}

.ant-page-header span {
	color: var(--text) !important;
}

.column-design {
	background-color: var(--bg-secondary) !important;
	border: var(--input-border) !important;
}

.column-design h5 {
	color: var(--text) !important;
}

.ant-select-arrow {
	color: var(--text) !important;
}

.ant-upload.ant-upload-select-picture-card {
	background-color: var(--bg) !important;
}

.ant-upload.ant-upload-select-picture-card div {
	color: var(--text) !important;
}

.ant-upload.ant-upload-select-picture-card .anticon-plus {
	color: var(--text) !important;
}

#csvFileInput {
	color: var(--text) !important;
	background-color: var(--bg) !important;
}

.ant-dropdown-trigger {
	color: var(--text) !important;
	background-color: var(--bg) !important;
}

.ant-dropdown-open {
	background-color: var(--bg-secondary) !important;
}

.report-section-card-title {
	color: var(--text) !important;
}

.role-list-title {
	color: var(--text) !important;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link:hover span {
	color: var(--text) !important;
	background-color: var(--bg) !important;
}

.ant-pagination-prev .ant-pagination-item-link,
.ant-pagination-next .ant-pagination-item-link {
	color: var(--text) !important;
	background-color: var(--bg) !important;
}

.ant-pagination-item-active {
	color: var(--text) !important;
	background-color: var(--bg) !important;
}

.table-hover {
	color: var(--text) !important;
}

.slick-track {
	display: flex !important;
}

.slick-slide {
	height: inherit !important;
}

.product-single-details .slick-slide > div {
	height: 100% !important;
	width: 100% !important;
	overflow: hidden !important;
}

.slick-prev {
	z-index: 10;
	left: 15px !important;
}

.slick-next {
	right: 15px !important;
}

.scrollbar-hide::-webkit-scrollbar {
	display: none;
}

.scrollbar-hide {
	-ms-overflow-style: none;
	scrollbar-width: none;
}

.ant-menu-submenu > .ant-menu {
	background-color: white !important;
	font-family: Poppins, sans-serif !important;
	color: #134e4a !important;
}

.ant-menu-sub > .ant-menu-item-selected {
	background: #99f6e4 !important;
}

.ant-menu-sub > .ant-menu-item a {
	color: #134e4a !important;
}

.ant-menu-submenu-expand-icon,
.ant-menu-submenu-arrow {
	color: white !important;
}

.ant-menu-submenu-title:hover {
	color: #99f6e4 !important;
}

.ant-menu-submenu-selected {
	color: #99f6e4 !important;
}

.ant-select-selection-search {
	display: none !important;
}

.ant-image-preview-img-wrapper {
	display: flex;
	justify-content: center;
	align-items: center;
}

.ant-layout-sider-collapsed {
	min-width: 0px !important;
	width: 0px !important;
	flex: 0 0 !important;
	max-width: 0px !important;
}

.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
	background-color: #99f6e4 !important;
	color: #000000 !important;
}

:is(.dark .ant-breadcrumb-separator) {
	color: white !important;
}

:is(.dark .ant-table) {
	color: white !important;
}

:is(.dark .ant-pagination-total-text) {
	color: white !important;
}

:is(.dark .ant-collapse-content) {
	background-color: #2e2d35 !important;
	color: white !important;
}

:is(.dark .ant-drawer-content) {
	background-color: #2e2d35 !important;
	color: white !important;
}

:is(.dark .ant-drawer-title) {
	color: white !important;
}

:is(.dark .ant-drawer-close) {
	color: red !important;
}

.ant-table-thead {
	background-color: #f3f4f6 !important;
	color: black !important;
}

.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after,
.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after {
	border-bottom: 2px solid white !important;
}

.ant-menu-title-content > a {
	padding: 10px 0 !important;
}

.ant-menu-inline .ant-menu-item::after {
	border-right: 3px solid #0f766e !important;
}

.ant-menu-inline .ant-menu-item {
	margin-bottom: 0px !important;
	margin-top: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,uBAAuB;CACvB,oBAAoB;CACpB,2BAA2B;CAC3B,yBAAyB;CACzB,eAAe;CACf,kBAAkB;CAClB,qBAAqB;CACrB,+BAA+B;CAC/B,yCAAyC;CACzC,2BAA2B;CAC3B,oBAAoB;CACpB,yBAAyB;CACzB,qBAAqB;CACrB,uBAAuB;CACvB,+BAA+B;CAC/B,wBAAwB;CACxB,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,oBAAoB;CACpB,2BAA2B;CAC3B,yBAAyB;CACzB,eAAe;CACf,kBAAkB;CAClB,qBAAqB;CACrB,+BAA+B;CAC/B,sCAAsC;CACtC,6BAA6B;CAC7B,iCAAiC;CACjC,yBAAyB;CACzB,qBAAqB;CACrB,uBAAuB;CACvB,+BAA+B;CAC/B,wBAAwB;CACxB,uBAAuB;AACxB;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB;oCACmC;AACpC;;AAEA;CACC,uCAAuC;CACvC,sBAAsB;CACtB,kBAAkB;CAClB,cAAc;CACd,SAAS;;CAET,0BAA0B;CAC1B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,aAAa;CACb,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,0CAA0C;CAC1C,qBAAqB;CACrB,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,YAAY;AACb;;AAEA;CACC,gDAAgD;CAChD,6BAA6B;AAC9B;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,qDAAqD;AACtD;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,6CAA6C;AAC9C;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,4BAA4B;CAC5B,uBAAuB;AACxB;;AAEA;;;CAGC,gDAAgD;CAChD,6BAA6B;AAC9B;;AAEA;;;CAGC,wCAAwC;AACzC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,wDAAwD;AACzD;;AAEA;CACC,8BAA8B;CAC9B,iCAAiC;AAClC;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;AAC9B;;AAEA;;CAEC,8CAA8C;AAC/C;;AAEA;;CAEC,8CAA8C;AAC/C;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,wDAAwD;AACzD;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gDAAgD;CAChD,sCAAsC;AACvC;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;;CAGC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;CAC7B,gDAAgD;AACjD;;AAEA;CACC,6BAA6B;CAC7B,sCAAsC;AACvC;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,6BAA6B;CAC7B,gDAAgD;AACjD;;AAEA;;;;;;CAMC,gDAAgD;AACjD;;AAEA;;;;;;CAMC,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;CAC7B,gDAAgD;AACjD;;AAEA;CACC,6BAA6B;CAC7B,gDAAgD;AACjD;;AAEA;CACC,6BAA6B;CAC7B,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;CAC7B,gDAAgD;AACjD;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,oDAAoD;AACrD;;AAEA;CACC,kDAAkD;AACnD;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,gDAAgD;CAChD,sCAAsC;AACvC;;AAEA;CACC,gDAAgD;CAChD,6BAA6B;CAC7B,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,gDAAgD;CAChD,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;CAC7B,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;CAC7B,sCAAsC;AACvC;;AAEA;CACC,gDAAgD;AACjD;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;;CAEC,6BAA6B;CAC7B,sCAAsC;AACvC;;AAEA;;CAEC,6BAA6B;CAC7B,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;CAC7B,sCAAsC;AACvC;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,uBAAuB;CACvB,sBAAsB;CACtB,2BAA2B;AAC5B;;AAEA;CACC,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;CACC,kCAAkC;CAClC,2CAA2C;CAC3C,yBAAyB;AAC1B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;;CAEC,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,yBAAyB;CACzB,qBAAqB;CACrB,oBAAwB;CACxB,yBAAyB;AAC1B;;AAEA;CACC,oCAAoC;CACpC,yBAAyB;AAC1B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qBAAqB;AACtB;;AAEA;CACC,oCAAoC;CACpC,uBAAuB;AACxB;;AAEA;;;CAGC,yCAAyC;AAC1C;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,6BAA6B;CAC7B,0BAA0B;AAC3B","sourcesContent":[".dark-theme {\n\t--bg: #1c1b20;\n\t--bg-secondary: #2e2d35;\n\t--bg-column: #36454f;\n\t--bg-item-selected: #2e2d35;\n\t--bg-item-active: #46464a;\n\t--text: #ffffff;\n\t--body-bg: #1c1b20;\n\t--sidenav-bg: #2e2d35;\n\t--table-cell-row-hover: #26252b;\n\t--form-item-label: rgba(255, 255, 255, 1);\n\t/* --table-head: #424242; */\n\t--input-border: none;\n\t--quick-links-bg: #2e2d35;\n\t--form-color: #525252;\n\t--text-color-2: #7858a6;\n\t--text-color-secondary: #864879;\n\t--text-color-hr: #864879;\n\t--shadow-color: #3730a3;\n}\n\n.light-theme {\n\t--bg: #f5f4f4;\n\t--bg-secondary: #ffffff;\n\t--bg-column: #f7f7f7;\n\t--bg-item-selected: #e6f7ff;\n\t--bg-item-active: #cef0ff;\n\t--text: #000000;\n\t--body-bg: #f8f8ff;\n\t--sidenav-bg: #344d67;\n\t--table-cell-row-hover: #fafafa;\n\t--form-item-label: rgba(0, 0, 0, 0.85);\n\t--table-head: rgb(51, 51, 51);\n\t--input-border: 1px solid #d9d9d9;\n\t--quick-links-bg: #f4f4f4;\n\t--form-color: #e6e6e6;\n\t--text-color-2: #37306b;\n\t--text-color-secondary: #146c94;\n\t--text-color-hr: #e2e2e2;\n\t--shadow-color: #c7d2fe;\n}\n\nbody {\n\tbackground-color: var(--body-bg) !important;\n}\n\n.ant-shadow {\n\tborder-radius: 16px;\n\tmargin-right: 24px;\n\tbox-shadow: 0 1px 15px -1px var(--shadow-color),\n\t\t0 1px 6px -4px var(--shadow-color);\n}\n\n.date {\n\tfont-family: Nunito, Roboto, sans-serif;\n\tbox-sizing: border-box;\n\tposition: relative;\n\tmargin: 0 auto;\n\ttop: 30px;\n\n\tborder: 4px double #51b27f;\n\tborder-radius: 3px;\n\ttext-align: center;\n}\n\n.date .month {\n\tletter-spacing: 2px;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\tbottom: -25px;\n\ttext-transform: uppercase;\n\ttext-align: center;\n}\n\n.date .day {\n\tbackground: var(--bg-secondary) !important;\n\tdisplay: inline-block;\n\tfont-size: 2em;\n\tmargin: 5px 0 0 -15px;\n}\n\n.date sup {\n\tposition: relative;\n\tbottom: 10px;\n}\n\n.ant-card {\n\tbackground-color: var(--bg-secondary) !important;\n\tcolor: var(--text) !important;\n}\n\n.new-card {\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.new-column-card {\n\tbackground-color: var(--bg-column) !important;\n}\n\n.ant-row {\n\tcolor: var(--text) !important;\n}\n\n.new-hr {\n\tborder-top: 1px solid var(--text-color-hr) !important;\n}\n\n.txt-color {\n\tcolor: var(--text) !important;\n}\n\n.txt-color-2 {\n\tcolor: var(--text-color-2) !important;\n}\n\n.txt-color-secondary {\n\tcolor: var(--text-color-secondary) !important;\n}\n\n.form-color {\n\tcolor: var(--form-color) !important;\n}\n\n.ant-layout {\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-page-header-heading-title {\n\tcolor: var(--text) !important;\n}\n\n.ant-page-header-back-button anticon {\n\tcolor: var(--text) !important;\n}\n\n.ant-layout-sider {\n\tbackground: white !important;\n\tcolor: black !important;\n}\n\n.ant-modal-content,\n.ant-modal-header,\n.ant-modal-title {\n\tbackground-color: var(--bg-secondary) !important;\n\tcolor: var(--text) !important;\n}\n\n.ant-menu.ant-menu-dark,\n.ant-menu-dark .ant-menu-sub,\n.ant-menu.ant-menu-dark .ant-menu-sub {\n\tbackground: var(--sidenav-bg) !important;\n}\n\n.logout-text {\n\tcolor: var(--text) !important;\n}\n\n.card-body {\n\tcolor: var(--text) !important;\n}\n\n.ant-typography {\n\tcolor: var(--text) !important;\n}\n\n.ant-form-item-label > label {\n\tcolor: var(--form-item-label) !important;\n}\n\n.ant-table {\n\tcolor: var(--text) !important;\n}\n\n.ant-table-cell-row-hover {\n\tbackground-color: var(--table-cell-row-hover) !important;\n}\n\n.ant-table-tbody > tr > .ant-table-cell {\n\tpadding-top: 0.5rem !important;\n\tpadding-bottom: 0.5rem !important;\n}\n\n.card-header {\n\tbackground-color: var(--bg) !important;\n}\n\n.card-header > div > h5 {\n\tcolor: var(--text) !important;\n}\n\n.table-responsive > h5 {\n\tcolor: var(--text) !important;\n}\n\n.card-custom {\n\tbackground-color: var(--bg) !important;\n}\n\n.card-custom h5 {\n\tcolor: var(--text) !important;\n}\n\n.card-custom h4 {\n\tcolor: var(--text) !important;\n}\n\n.report-section-table,\n.detail-account-table {\n\tcolor: var(--text) !important;\n}\n\n.report-section-table h5,\n.detail-account-table h5 {\n\tcolor: var(--text) !important;\n}\n\n.report-section-table thead,\n.detail-account-table thead {\n\tbackground-color: var(--table-head) !important;\n}\n\n.report-section-table thead th,\n.detail-account-table thead th {\n\tbackground-color: var(--table-head) !important;\n}\n\n.ant-empty-description {\n\tcolor: var(--text) !important;\n}\n\n.ant-table-placeholder:hover .ant-table-cell {\n\tbackground-color: var(--table-cell-row-hover) !important;\n}\n\n.loading h5 {\n\tcolor: var(--text) !important;\n}\n\n.ant-page-header-heading {\n\tcolor: var(--text) !important;\n}\n\n.ant-page-header-back-button {\n\tcolor: var(--text) !important;\n}\n\n.range-picker {\n\tbackground-color: var(--bg-secondary) !important;\n\tborder: var(--input-border) !important;\n}\n\n.ant-picker {\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-picker-input > input {\n\tcolor: var(--text) !important;\n}\n\n.ant-picker-separator,\n.ant-picker-suffix,\n.ant-picker-clear {\n\tcolor: var(--text) !important;\n}\n\n.ant-input {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-btn-dashed {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-btn-dashed:hover {\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-input-number {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-input-number-status-error:not(.ant-input-number-disabled):not(\n\t\t.ant-input-number-borderless\n\t).ant-input-number,\n.ant-input-number-status-error:not(.ant-input-number-disabled):not(\n\t\t.ant-input-number-borderless\n\t).ant-input-number:hover {\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-input-status-error:not(.ant-input-disabled):not(\n\t\t.ant-input-borderless\n\t).ant-input,\n.ant-input-status-error:not(.ant-input-disabled):not(\n\t\t.ant-input-borderless\n\t).ant-input:hover {\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-input-number-handler-wrap span {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-select-dropdown {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-select-item .ant-select-item-option {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-select-item-option-content {\n\tcolor: var(--text) !important;\n}\n\n.ant-select-multiple .ant-select-selection-item {\n\tbackground-color: transparent !important;\n}\n\n.ant-select-item-option-selected {\n\tbackground-color: var(--bg-item-selected) !important;\n}\n\n.ant-select-item-option-active:not(.ant-select-item-option-disabled) {\n\tbackground-color: var(--bg-item-active) !important;\n}\n\n.dashboard-card {\n\tcolor: white;\n\tborder: none;\n\tborder-radius: 10px;\n}\n\n.dashboard-card h3 {\n\tcolor: white;\n}\n\n.dashboard-card span {\n\tcolor: white;\n}\n\n.dashboard-card-bg {\n\tbackground-color: var(--bg-secondary);\n}\n\n.ant-card-head-title {\n\tcolor: var(--text) !important;\n}\n\n.ant-card-head {\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.ant-card-bordered {\n\tbackground-color: var(--bg-secondary) !important;\n\tborder: var(--input-border) !important;\n}\n\n.ant-page-header {\n\tbackground-color: var(--bg-secondary) !important;\n\tcolor: var(--text) !important;\n\tborder: var(--input-border) !important;\n}\n\n.ant-page-header span {\n\tcolor: var(--text) !important;\n}\n\n.column-design {\n\tbackground-color: var(--bg-secondary) !important;\n\tborder: var(--input-border) !important;\n}\n\n.column-design h5 {\n\tcolor: var(--text) !important;\n}\n\n.ant-select-arrow {\n\tcolor: var(--text) !important;\n}\n\n.ant-upload.ant-upload-select-picture-card {\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-upload.ant-upload-select-picture-card div {\n\tcolor: var(--text) !important;\n}\n\n.ant-upload.ant-upload-select-picture-card .anticon-plus {\n\tcolor: var(--text) !important;\n}\n\n#csvFileInput {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-dropdown-trigger {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-dropdown-open {\n\tbackground-color: var(--bg-secondary) !important;\n}\n\n.report-section-card-title {\n\tcolor: var(--text) !important;\n}\n\n.role-list-title {\n\tcolor: var(--text) !important;\n}\n\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link:hover span {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-pagination-prev .ant-pagination-item-link,\n.ant-pagination-next .ant-pagination-item-link {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg) !important;\n}\n\n.ant-pagination-item-active {\n\tcolor: var(--text) !important;\n\tbackground-color: var(--bg) !important;\n}\n\n.table-hover {\n\tcolor: var(--text) !important;\n}\n\n.slick-track {\n\tdisplay: flex !important;\n}\n\n.slick-slide {\n\theight: inherit !important;\n}\n\n.product-single-details .slick-slide > div {\n\theight: 100% !important;\n\twidth: 100% !important;\n\toverflow: hidden !important;\n}\n\n.slick-prev {\n\tz-index: 10;\n\tleft: 15px !important;\n}\n\n.slick-next {\n\tright: 15px !important;\n}\n\n.scrollbar-hide::-webkit-scrollbar {\n\tdisplay: none;\n}\n\n.scrollbar-hide {\n\t-ms-overflow-style: none;\n\tscrollbar-width: none;\n}\n\n.ant-menu-submenu > .ant-menu {\n\tbackground-color: white !important;\n\tfont-family: Poppins, sans-serif !important;\n\tcolor: #134e4a !important;\n}\n\n.ant-menu-sub > .ant-menu-item-selected {\n\tbackground: #99f6e4 !important;\n}\n\n.ant-menu-sub > .ant-menu-item a {\n\tcolor: #134e4a !important;\n}\n\n.ant-menu-submenu-expand-icon,\n.ant-menu-submenu-arrow {\n\tcolor: white !important;\n}\n\n.ant-menu-submenu-title:hover {\n\tcolor: #99f6e4 !important;\n}\n\n.ant-menu-submenu-selected {\n\tcolor: #99f6e4 !important;\n}\n\n.ant-select-selection-search {\n\tdisplay: none !important;\n}\n\n.ant-image-preview-img-wrapper {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.ant-layout-sider-collapsed {\n\tmin-width: 0px !important;\n\twidth: 0px !important;\n\tflex: 0 0 0px !important;\n\tmax-width: 0px !important;\n}\n\n.ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {\n\tbackground-color: #99f6e4 !important;\n\tcolor: #000000 !important;\n}\n\n:is(.dark .ant-breadcrumb-separator) {\n\tcolor: white !important;\n}\n\n:is(.dark .ant-table) {\n\tcolor: white !important;\n}\n\n:is(.dark .ant-pagination-total-text) {\n\tcolor: white !important;\n}\n\n:is(.dark .ant-collapse-content) {\n\tbackground-color: #2e2d35 !important;\n\tcolor: white !important;\n}\n\n:is(.dark .ant-drawer-content) {\n\tbackground-color: #2e2d35 !important;\n\tcolor: white !important;\n}\n\n:is(.dark .ant-drawer-title) {\n\tcolor: white !important;\n}\n\n:is(.dark .ant-drawer-close) {\n\tcolor: red !important;\n}\n\n.ant-table-thead {\n\tbackground-color: #f3f4f6 !important;\n\tcolor: black !important;\n}\n\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-selected::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-item-active::after,\n.ant-menu-horizontal:not(.ant-menu-dark) > .ant-menu-submenu-selected::after {\n\tborder-bottom: 2px solid white !important;\n}\n\n.ant-menu-title-content > a {\n\tpadding: 10px 0 !important;\n}\n\n.ant-menu-inline .ant-menu-item::after {\n\tborder-right: 3px solid #0f766e !important;\n}\n\n.ant-menu-inline .ant-menu-item {\n\tmargin-bottom: 0px !important;\n\tmargin-top: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
